import React from "react";
import { Box, Flex, IconOnePassDelivery, Text, } from "@catchoftheday/cg-components";
export const FreeDelivery = () => {
    return (<Flex alignItems="center">
      <Box flex="1 1 auto" mr={5}>
        <IconOnePassDelivery width="42px" height="auto"/>
      </Box>
      <Box flex="1 1 auto" width="100%">
        <Text fontSize="base" m={0} fontWeight="medium">
          Free delivery on eligible items or orders with{" "}
          <strong>Kmart, Target and Bunnings Warehouse</strong>
        </Text>
      </Box>
    </Flex>);
};
